import React from 'react';
import { FormattedMessageType, VariantType } from '../../../../../types';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';
import styles from './availability.module.pcss';

interface AvailabilityProps {
  isAvailable: boolean;
  variantType: VariantType;
}

const getVariantTypeName = (t: VariantType): FormattedMessageType => {
  switch (t) {
    case VariantType.CaseSize:
      return { id: 'product.variant.types.short.CaseSize', fallback: 'case size' };
    case VariantType.RingSize:
      return { id: 'product.variant.types.short.RingSize', fallback: 'size' };
    case VariantType.EarringSize:
      return { id: 'product.variant.types.short.EarringSize', fallback: 'size' };
    case VariantType.BraceletLength:
      return { id: 'product.variant.types.short.BraceletLength', fallback: 'length' };
    case VariantType.NecklaceLength:
      return { id: 'product.variant.types.short.NecklaceLength', fallback: 'length' };
    default:
      return { id: 'product.variant.types.short.Variant', fallback: 'variant' };
  }
};

function Availability({ isAvailable, variantType }: AvailabilityProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const variantTypeName = formattedMessage(getVariantTypeName(variantType));
  const availabilityMessage = formattedMessage({
    id: 'product.other.styles.unavailable',
    values: { 0: variantTypeName },
    fallback: `Not available in the ${variantTypeName} selected`
  });
  return <>{!isAvailable && <span className={styles.availability}>{availabilityMessage}</span>}</>;
}

export default Availability;
